import type { EbookState } from 'reactApp/modules/ebook/ebook.types';
import type { RootState } from 'reactApp/store';

const getEbookStore = (state: RootState) => state.ebook as EbookState;

export const getEbookConfig = (state: RootState) => getEbookStore(state).options;
export const getIsActiveBookmark = (state: RootState) => getEbookStore(state).isActiveBookmark;
export const getIsOptionDlgShown = (state: RootState) => getEbookStore(state).isOptionDlgShown;
export const getDownloadEbookClick = (state: RootState) => getEbookStore(state).downloadEbookClick;
